import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import InstituteCreateForm from '../components/institutions/InstituteCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';

const InstituteCreatePage = () => {
  const { societySlug } = useParams();

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>Add Institute - PakPoints</title>
        <meta name="description" content="Add an educational institute to your society" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societySlug ? (
          <SocietyContextMobileNav societySlug={societySlug} activeSection="institutes" />
        ) : null}
        <div className="py-8">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <InstituteCreateForm />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default InstituteCreatePage;
